import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.ShipPainting;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "ShipPainting.Phaser.IntroductionScene.1",
            "ShipPainting.Phaser.IntroductionScene.2",
            "ShipPainting.Phaser.IntroductionScene.3",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/ShipPainting/scenes/GameIntro.ts